module.exports = __webpack_public_path__ + "73f0a88bbca1bec19fb1303c689d04c6.woff2";